import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const fetchObsolescenceParameters = () => apiActionCreator({
  'endpoint': '/obsolescence-parameters/',
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_OBSOLESCENCE_PARAMETERS_REQUEST,
    ActionTypes.FETCH_OBSOLESCENCE_PARAMETERS_SUCCCESS,
    [
      ActionTypes.FETCH_OBSOLESCENCE_PARAMETERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const saveObsParameters = (obsParamsData = []) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/obsolescence-parameters/',
      'authenticated': true,
      'types': [
        ActionTypes.SAVE_OBS_PARAMS_REQUEST,
        [
          () => {
            dispatch(fetchObsolescenceParameters());
            return {'type': ActionTypes.SAVE_OBS_PARAMS_SUCCESS};
          },
          (response) => buildSuccessMessage(response, 'Información subida satisfactoriamente'),
        ],
        [
          ActionTypes.SAVE_OBS_PARAMS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': obsParamsData,
    })
  );
};
